const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/chat/api-factory');
const serviceFactory = require('../resources/chat/service-factory');
const PlatformConfig = require('../platform');

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/chatservices/${apiConfig.apiversion}/`,
  });

  const service = serviceFactory({ api });
  const p = '[{keys:metaData}].';

  return app => app
 
    .match((
      `${p}chat.getFetchUserList[{keys:guidStr}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.getFetchUserList(req.params)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
    .match((
      `${p}chat.getFetchChatHistory[{keys:inputs}][{keys:guidStr}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.getFetchChatHistory(req.params.inputs, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
}

module.exports = addRoutes;